const getNextDivisible = (maxNumber, binSize) => {
  if (maxNumber % binSize === 0) return maxNumber;
  return maxNumber + binSize - (maxNumber % binSize);
};

const getPrevDivisible = (minNumber, binSize) => {
  return minNumber - (minNumber % binSize);
};

const getSmootherBinSize = (num) => {
  if (num > 1) {
    num = Math.ceil(num);
    if (num < 10) {
      if (num > 5) return 10;
      else if (num >= 3) return 5;
      return num;
    } else {
      var pow = 0;
      while (num / Math.pow(10, pow) > 9) pow += 1;
      return getNextDivisible(num, Math.pow(10, pow));
    }
  } else {
    var pow = 0;
    while (num / Math.pow(10, pow) <= 0.9) {
      pow -= 1;
    }
    return (
      Math.round(getNextDivisible(num, Math.pow(10, pow)) * Math.pow(10, -pow)) / Math.pow(10, -pow)
    );
  }
};

const calculateMinMaxValue = (minValue, maxValue, zeroBase, ticks) => {
  if (minValue == maxValue && minValue == 0) {
    maxValue = 10;
  }
  if (minValue == maxValue && minValue > 0) {
    minValue = minValue - minValue * 0.25;
    maxValue = maxValue + maxValue * 0.25;
  }
  if (minValue > 0 && zeroBase === true) {
    minValue = 0;
  }

  let binSize = null;

  if (minValue < 0 && maxValue > 0) {
    const minAbsValue = -1 * minValue;
    const negativeScalePerc = minAbsValue / (maxValue - minValue);
    const positiveScalePerc = 1 - negativeScalePerc;
    //Computing the number ticks needed on -ve & +ve part of the scale based on min & max Absolute value
    if (positiveScalePerc > negativeScalePerc) {
      const numPositiveTicks = Math.floor((ticks - 1) * positiveScalePerc);
      const numNegativeTicks = ticks - numPositiveTicks - 1;
      binSize = getSmootherBinSize(maxValue / numPositiveTicks);
      //Checking if computed bin size & nos. of ticks covers both max & min values
      if (binSize * numPositiveTicks >= maxValue && binSize * numNegativeTicks >= minAbsValue) {
        minValue = binSize * numNegativeTicks * -1; // Converting it back to a negative number
        maxValue = binSize * numPositiveTicks;
        return {
          minValue,
          maxValue,
          binSize,
        };
      }
    } else {
      const numNegativeTicks = Math.floor((ticks - 1) * negativeScalePerc);
      const numPositiveTicks = ticks - numNegativeTicks - 1;
      binSize = getSmootherBinSize(minAbsValue / numNegativeTicks);

      if (binSize * numPositiveTicks >= maxValue && binSize * numNegativeTicks >= minAbsValue) {
        minValue = binSize * numNegativeTicks * -1; // Converting it back to a negative number
        maxValue = binSize * numPositiveTicks;
        return {
          minValue,
          maxValue,
          binSize,
        };
      }
    }
  }

  var num = (maxValue - minValue) / ((ticks || 10) - 1);
  binSize = getSmootherBinSize(num);
  if (minValue < 0) {
    minValue = -1 * getNextDivisible(minValue * -1, binSize);
  } else if (minValue > 0) {
    minValue = getPrevDivisible(minValue, binSize);
  }
  maxValue = getNextDivisible(maxValue, binSize);
  if (ticks != null) {
    const tickDifference = ticks - ((maxValue - minValue) / binSize + 1);
    if (tickDifference > 0) {
      if (minValue == 0) {
        maxValue += Math.floor(tickDifference) * binSize;
      } else {
        minValue -= Math.floor(tickDifference / 2) * binSize;
        maxValue += (Math.floor(tickDifference / 2) + (tickDifference % 2)) * binSize;
      }
    } else if (tickDifference < 0) {
      if (minValue == 0) {
        maxValue -= Math.floor(-1 * tickDifference) * binSize;
      } else {
        minValue += Math.floor((-1 * tickDifference) / 2) * binSize;
        maxValue -= (Math.floor((-1 * tickDifference) / 2) + ((-1 * tickDifference) % 2)) * binSize;
      }
    }
  }

  minValue = Math.round(minValue * Math.pow(10, 8)) / Math.pow(10, 8);
  maxValue = Math.round(maxValue * Math.pow(10, 8)) / Math.pow(10, 8);
  return {
    minValue: minValue,
    maxValue: maxValue,
    binSize: binSize,
  };
};

const calculateLogMinMaxValue = (minValue, maxValue) => {
  let niceMinValue = Math.floor(Math.log10(minValue));
  let niceMaxValue = Math.ceil(Math.log10(maxValue));
  return {
    minValue: Math.pow(10, niceMinValue),
    maxValue: Math.pow(10, niceMaxValue),
  };
};

const AxiomScaleBand = () => {
  var localScale = {
    padding: 0,
    paddingOuter: 0,
    domain: [],
    range: [],
    maxBarWidth: +Infinity,
  };

  var calculationObject = {};

  function reCalculate() {
    var rangeDiffOriginal = localScale.range[1] - localScale.range[0];
    rangeDiffOriginal = rangeDiffOriginal >= 0 ? rangeDiffOriginal : -1 * rangeDiffOriginal;
    var rangeBandOriginal = rangeDiffOriginal / localScale.domain.length;
    calculationObject.paddingOuter = rangeBandOriginal * localScale.paddingOuter;

    var rangeDiff = rangeDiffOriginal - calculationObject.paddingOuter * 2;
    var rangeBand = rangeDiff / localScale.domain.length;
    var localPadding = rangeBand * localScale.padding;
    var localBarWidth = rangeBand - localPadding;
    if (localBarWidth > localScale.maxBarWidth) {
      localPadding += localBarWidth - localScale.maxBarWidth;
      localBarWidth = localScale.maxBarWidth;
    }
    calculationObject.finalPadding = localPadding;
    calculationObject.finalBarWidth = localBarWidth;
    calculationObject.rangeBand = rangeBand;
  }
  var scale = function () {
    // if(arguments.length > 1){
    //   return console.error("invalid number of arguments. Expected only 1");
    // }
    if (arguments.length === 0) {
      return localScale;
    } else {
      var index = localScale.domain.indexOf(arguments[0]);
      if (index == -1) {
        return 0;
      }
      var rangeDiffOriginal = localScale.range[1] - localScale.range[0];
      return rangeDiffOriginal >= 0
        ? localScale.range[0] +
            calculationObject.paddingOuter +
            index * calculationObject.rangeBand +
            calculationObject.finalPadding / 2
        : localScale.range[0] +
            calculationObject.finalPadding / 2 -
            ((index + 1) * calculationObject.rangeBand + calculationObject.paddingOuter);
    }
  };
  scale.padding = function () {
    if (arguments.length > 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    if (arguments.length === 0) {
      return localScale.padding;
    } else {
      localScale.padding = arguments[0];
    }
    reCalculate();
    return scale;
  };
  scale.paddingOuter = function () {
    if (arguments.length > 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    if (arguments.length === 0) {
      return localScale.paddingOuter;
    } else {
      localScale.paddingOuter = arguments[0];
    }
    reCalculate();
    return scale;
  };
  scale.domain = function () {
    if (arguments.length > 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    if (arguments.length === 0) {
      return localScale.domain;
    } else {
      localScale.domain = arguments[0];
    }
    reCalculate();
    return scale;
  };
  scale.range = function () {
    if (arguments.length > 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    if (arguments.length === 0) {
      return localScale.range;
    } else {
      localScale.range = arguments[0];
    }
    reCalculate();
    return scale;
  };
  scale.maxBarWidth = function () {
    if (arguments.length > 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    if (arguments.length === 0) {
      return localScale.maxBarWidth;
    } else {
      if (arguments[0] == null) {
        localScale.maxBarWidth = +Infinity;
      } else {
        localScale.maxBarWidth = arguments[0];
      }
    }
    reCalculate();
    return scale;
  };
  scale.bandwidth = function () {
    if (arguments.length > 0) {
      return console.error("invalid number of arguments. No arguments expected");
    }
    if (arguments.length === 0) {
      return calculationObject.finalBarWidth;
    }
    return scale;
  };
  scale.inverse = function () {
    if (arguments.length != 1) {
      return console.error("invalid number of arguments. Expected only 1");
    }
    var rangeDiffOriginal = localScale.range[1] - localScale.range[0];
    var index = 0;
    if (rangeDiffOriginal >= 0) {
      index = Math.floor(
        (Math.ceil(arguments[0]) - calculationObject.paddingOuter - localScale.range[0]) /
          calculationObject.rangeBand
      );
    } else {
      index = Math.floor(
        (localScale.range[0] - (Math.ceil(arguments[0]) + calculationObject.paddingOuter)) /
          calculationObject.rangeBand
      );
    }

    if (index < 0 || index >= localScale.domain.length) {
      return "";
    } else {
      return localScale.domain[index];
    }
  };
  scale.copy = function () {
    var copyScale = AxiomScaleBand();
    Object.keys(localScale).forEach((k) => {
      copyScale = copyScale[k](localScale[k]);
    });
    return copyScale;
  };
  scale.round = function () {
    return false;
  };
  return scale;
};

module.exports = {
  calculateMinMaxValue: calculateMinMaxValue,
  calculateLogMinMaxValue: calculateLogMinMaxValue,
  AxiomScaleBand: AxiomScaleBand,
};
